module.exports = __webpack_public_path__ + "img/tpd.e8d168ea.svg";